<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import Button from '~/components/ui/Button.vue'
import AuCallout from '~/components/ui/AuCallout.vue'

const { t } = useI18n()
</script>

<template>
  <div>
    <h1
      class="mb-8 text-center text-4xl font-semibold"
      v-text="t('register.success.title')"
    />
    <div>
      <AuCallout
        variant="success"
        :title="t('register.success.info')"
      >
        <ol class="mt-4 list-decimal space-y-2">
          <li v-text="t('register.success.confirm1')" />
          <li v-html="t('register.success.confirm2')" />
        </ol>
      </AuCallout>
    </div>
    <div class="my-4 text-right">
      <Button
        href="/"
        size="lg"
      >
        {{ t('back') }}
      </Button>
    </div>
  </div>
</template>
